import { HttpService, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { MS_PER_MINUTE, extractFilenameFromHeaders } from '@skylab-shared/utils';
import { AxiosResponse } from 'axios';
import { ExportQueryParameters } from '../../common/export/export-query.parameters';
import { ExportResult } from '../../common/export/export-query.result';
import { ExportQuery } from '../../common/export/export.query-base';

export interface SalesByPeriodExportParameters extends ExportQueryParameters { }

export class SalesByPeriodExportQuery extends ExportQuery<ExportResult> {
    public constructor(parameters: SalesByPeriodExportParameters) {
        super(parameters);
    }
}

export class SalesByPeriodExportQueryHandlerBase implements QueryHandler<SalesByPeriodExportQuery, ExportResult> {
    private static Url = TaggedUrl.join('salesByPeriod/export', [Tags.Api]);

    public constructor(private readonly http: HttpService) {  }

    public async handleAsync({ parameters }: SalesByPeriodExportQuery): Promise<ExportResult> {
        const requestData = {
            compress: parameters.compress,
            password: parameters.password,
            config: {
                parameters: JSON.stringify(parameters.parameters),
                columns: parameters.columns
            }
        };

        const response = await this.http.post<Blob>(SalesByPeriodExportQueryHandlerBase.Url, requestData, { responseType: 'blob', timeout: 3 * MS_PER_MINUTE });
        return {
            file: response.data,
            filename: extractFilenameFromHeaders(<AxiosResponse>response) ?? ''
        };
    }
}
